import { useMutation } from '@tanstack/react-query';

import type { DeleteScanningDeviceResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDeleteScanningDeviceMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; id: string }) =>
      HttpClient.request<DeleteScanningDeviceResponse>({
        method: 'DELETE',
        url: `${params.url}/${params.id}`,
      }),
  });
